import React from 'react'
import PicklistField from 'core/components/validatedForm/DropdownField'
import Dropdown from 'core/elements/dropdown'

export default function AppVersionPicklistField({ options, id = 'version', label = 'Version' }) {
  return (
    <PicklistField DropdownComponent={Dropdown} id={id} label={label} items={options} required />
  )
}
